import angular from "angular";

import authenticationModule from "./authentication/authentication.module.js";

export default angular.module("sbApp.core", [authenticationModule.name]);
